// @ts-strict-ignore
import { GetConfig } from "phoenix/constants";
import { GlobalState } from "phoenix/redux/GlobalState";

export function GetFromSnexStore<TData>(selector: (s: GlobalState) => TData): TData {
    return selector(GetConfig().Store.getState());
}